import {
  CreateMeetingPayload,
  MeetingListResponse,
  MeetingQueryPayload,
  MeetingType,
  ApproveMeetingPayload,
} from '../types/meeting';
import api from '../api/axios';
import { MeetingRequestData } from '../components/Meeting/ScheduleMeeting';
import { ApprovedMeetingInterface } from '../types/approvedMeeting';
import { decryptData } from '../utils/decrypt';

export const getAllMeeting = async (): Promise<MeetingType[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/meeting-request`);
    
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

export const getMeetingByStatus = async (
  payload: MeetingQueryPayload
): Promise<MeetingListResponse> => {
  try {
    const {
      page = 1,
      limit = 10,
      status = 'APPROVED', // default to APPROVED
      sortBy = 'createdAt',
      sortOrder = 'DESC',
    } = payload;

    // ✅ Use relative path; token is attached automatically via api instance
    const url = `/meetings/all`;

    const response = await api.get(url, {
      params: {
        page,
        limit,
        status,
        sortBy,
        sortOrder,
      },
      // headers: {
      //   'Cache-Control': 'no-cache, no-store, must-revalidate',
      //   Pragma: 'no-cache',
      //   Expires: '0',
      // },
    });

    console.log('✅ API Response for getMeetingByStatus:', response.data);

      const decrypted = decryptData(response.data, response.data.iv);
      return decrypted;

    // return response.data;
  } catch (error) {
    console.error(' Error fetching meeting data:', error);
    throw error;
  }
};

export const getMeetingById = async (id: number): Promise<MeetingRequestData> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/meeting-request/${id}`);

    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

export const ApprovedMeeting = async (
  value: CreateMeetingPayload,
  id: number | string
): Promise<CreateMeetingPayload> => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/meeting-request/${id}`,
      value
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

// Approve meeting request
export const approveMeetingRequest = async (
  id: number,
  payload: ApproveMeetingPayload
): Promise<unknown> => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/meeting-request/${id}/approve`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error approving meeting request:', error);
    throw error;
  }
};

export const getApprovedMeetingDetailsById = async (
  id: number
): Promise<ApprovedMeetingInterface> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/meetings/${id}`);

    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

export const updateMeeting = async (id: number, value: unknown): Promise<unknown> => {
  try {
    const response = await api.post(`${import.meta.env.VITE_API_BASE_URL}/meetings/${id}`, value);

    return response.data;
  } catch (error) {
    console.error('Error updating meeting:', error);
    throw error;
  }
};

export const sendReminder = async (id: number): Promise<void> => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/meetings/${id}/send-reminders`
    );

    return response.data;
  } catch (error) {
    console.error('Error updating meeting:', error);
    throw error;
  }
};

export const rejectMeeting = async (id: number): Promise<void> => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/meeting-request/${id}/reject`
    );

    return response.data;
  } catch (error) {
    console.error('Error updating meeting:', error);
    throw error;
  }
};

// export const forwardMeeting = async ({
//   sendEmail,
//   id,
//   notes,
// }: {
//   sendEmail: boolean;
//   id: number;
//   notes: string;
// }): Promise<void> => {
//   try {
//     const response = await api.post(
//       `${import.meta.env.VITE_API_BASE_URL}/meeting-request/${id}/forward`,
//       {
//         sendEmail,
//         notes,
//       }
//     );

//     return response.data;
//   } catch (error) {
//     console.error('Error updating meeting:', error);
//     throw error;
//   }
// };


export const forwardMeeting = async ({
  id,
  payload,
}: {
  id: number;
  payload: any; // or type ForwardMeetingSubmitDto
}): Promise<any> => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/meeting-request/${id}/forward`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error('Error forwarding meeting:', error);
    throw error;
  }
};
